import React, { Component } from "react";

import styles from "./styles.scss";
import { connect } from "react-redux";
import { actions } from "./redux";

import CSSModules from "react-css-modules";
import { CircularProgress } from "@material-ui/core";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Route, Switch } from "react-router";
import ImportStatusOverview from "./ImportStatusOverview/ImportStatusOverview";
import ImportStatusRules from "./ImportStatusRules/ImportStatusRules";
import ImportStatusTags from "./ImportStatusTags/ImportStatusTags";

import masterImportService from "../../../services/masterImport";

@CSSModules(styles, { allowMultiple: true })
class ImportStatus extends Component {


  constructor(props) {

    super(props);
    this.state = {
      id: props.match.params.id,
    };
  }

  componentDidMount() {
    // if(this.props.importStatus == null)
    this.props.getData(this.state.id);
  }

  render() {

    const data = this.props.importStatus;
    const showStackTrace = this.props.showStackTrace;

    if (data == null)
      return (<CircularProgress></CircularProgress>)

    const importStatus = data.importStatus;
    const logs = data.logs;

    return (

      <div class={""}>

        <div class="header-grid">

          <div>
            <h1 class={"no-v-margin"}>{importStatus.fileName}</h1>
          </div>

          <div class="config-status-container center-children"
               status={importStatus.status}>
            <span>{masterImportService.importStatusCodeToText(importStatus.status)}</span>
          </div>
        </div>

        <div styleName={"dates"}>
          <div>Uploaded On: {importStatus.createdOnUtc.toLocaleString()}</div>
          {importStatus.modifiedOnUtc && <div>Modified On: {importStatus.modifiedOnUtc.toLocaleString()}</div>}
        </div>

        <div styleName={"configuration-container"}>

          {/* Navigation tabs between sub-setup */}
          <div styleName="flex-tabs">
            <Link to={`/MasterRules/Import/Status/${this.state.id}/Overview`}>
              <div styleName="flex-tab" >
                <span>Status</span>
              </div>
            </Link>
            <Link to={`/MasterRules/Import/Status/${this.state.id}/TagLabels`}>
              <div styleName="flex-tab">
                <span>Tag Labels</span>
              </div>
            </Link>
            <Link to={`/MasterRules/Import/Status/${this.state.id}/Rules`}>
              <div styleName="flex-tab">
                <span>Master Rules</span>
              </div>
            </Link>
          </div>

          {/* Actual rendered content */}
          <Switch>
            <Route path={`/MasterRules/Import/Status/:id/Overview`}
                   render={(routeProps) => (<ImportStatusOverview {...data} {...routeProps}/>)}></Route>
            <Route path={`/MasterRules/Import/Status/:id/TagLabels/:label`}
                   render={(routeProps) => (<ImportStatusTags {...data} {...routeProps}/>)}></Route>
            <Route path={`/MasterRules/Import/Status/:id/TagLabels`}
                   render={(routeProps) => (<ImportStatusTags {...data} {...routeProps}/>)}></Route>
            <Route path={`/MasterRules/Import/Status/:id/Rules/:ruleId`}
                   render={(routeProps) => (<ImportStatusRules {...data} {...routeProps}/>)}></Route>
            <Route path={`/MasterRules/Import/Status/:id/Rules`}
                   render={(routeProps) => (<ImportStatusRules {...data} {...routeProps}/>)}></Route>
          </Switch>


        </div>





      </div>

    );
  }

}

const bindAction = dispatch => {
  return {

    getData: (id) => dispatch(actions.getData(id)),

  };
};

const mapStateToProps = state => ({
  importStatus: state.importStatus.importStatus,
  isBusy: state.importStatus.isBusy,
  showStackTrace: state.importStatus.showStackTrace,

});

export default connect(
  mapStateToProps,
  bindAction
)(ImportStatus);



// WEBPACK FOOTER //
// ./src/ui/ImportOverview/ImportStatus/ImportStatus.js